/* istanbul ignore file */
import React from 'react';
import {
  useFieldHelper,
  TextField,
  DurationBetweenTwoDatesFieldProps,
  DurationBetweenTwoDatesField,
} from 'framework/ui/field';
import ContractInfinitySymbol from './ContractInfinitySymbol';

const ContractDurationField = (props: DurationBetweenTwoDatesFieldProps) => {
  const { getValue: getIsIndefiniteValue } = useFieldHelper({ source: 'isIndefinite' });
  const indefinite = getIsIndefiniteValue();

  return indefinite ? (
    <TextField value={<ContractInfinitySymbol />} {...props} />
  ) : (
    <DurationBetweenTwoDatesField {...props} />
  );
};

export default ContractDurationField;
